
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 1H4v1h4V1zM0 2h3V0h6v2h3v3h-1v9H1V5H0V2zm1 2h10V3H1v1zm2 1H2v8h8V5H3zm1 2h1v4H4V7zm4 0H7v4h1V7z","fill":"#8A8888"}})])
          )
        }
      }
    